// 基因卡的兩個純函式（GenomeCard.vue 與 /nft/soulfish/ 資料庫共用）。
// 條碼：數字越大線越粗，大寫字母中線，小寫細線——跟作品外框裡的 hash 條碼同一條規則
export const barW = ch => { const d = parseInt(ch, 10); if (!isNaN(d)) return 1 + d * 0.42; return /[A-Z]/.test(ch) ? 1.6 : 0.9 }
// 魚：正弦波 0→π 是身體、到 3/2π 收尾，上下鏡射，依線條密度疊成輪廓；體型放大縮小。features 帶 raw（原始值）時用 raw，否則用顯示值
export function fishPaths(it) {
  const f = Object.fromEntries((it.features || []).map(x => [x.key, x.raw ?? x.value])); const size = f.fishSize === 'large' ? 1.15 : f.fishSize === 'tiny' ? 0.72 : 1; const lines = f.fishThickness ? Math.min(7, Math.max(3, Math.round(Number(f.fishThickness) / 10))) : 5; const out = []
  for (let k = 0; k < lines; k++) { const ratio = 1 - k * (0.6 / lines); const amp = 18 * size * ratio; let up = '', down = ''; for (let i = 0; i <= 48; i++) { const x = i / 48; const t = x * Math.PI * 1.5; const y = Math.sin(t) * amp * (x < 2 / 3 ? 1 : 0.85); const px = (12 + x * 136).toFixed(1); up += (i ? 'L' : 'M') + px + ' ' + (28 - y).toFixed(1) + ' '; down += 'L' + px + ' ' + (28 + y).toFixed(1) + ' ' }
    const downRev = down.trim().split('L').filter(Boolean).reverse().map(s => 'L' + s).join(''); out.push(up + downRev + 'Z') }
  return out
}
// 色的亮度（0–1，sRGB 相對亮度的近似）：只認 #rgb／#rrggbb，其他（CSS 色名）回 null 讓呼叫端自己判斷
export function luminance(c) {
  const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(c || '').trim()); if (!m) return null
  let h = m[1]; if (h.length === 3) h = h.split('').map(x => x + x).join('')
  const [r, g, b] = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16) / 255).map(v => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4))
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}
// 從一組調色盤挑卡片的強調色：第一個不太暗也不太亮的；都不合就用紙色
export function pickAccent(list, fallback = '#d9d6cc') {
  for (const c of list || []) { const l = luminance(c); if (l !== null && l > 0.06 && l < 0.8) return c }
  return fallback
}
